import { useEffect, useState } from 'react';
import logger from '../logger';
import { MFDataPrefetch } from '../prefetch';
import { prefetch } from '../universal';
import { getScope } from '../common/runtime-utils';
import { useFirstMounted } from './utils';
export const usePrefetch = (options) => {
    const isFirstMounted = useFirstMounted();
    if (isFirstMounted) {
        const startTiming = performance.now();
        logger.info(`2. Start Get Prefetch Data: ${options.id} - ${options.functionId || 'default'} - ${startTiming}`);
    }
    const { id, functionId, deferId } = options;
    const prefetchInfo = {
        id,
        functionId,
    };
    const mfScope = getScope();
    let state;
    const prefetchResult = prefetch(options);
    if (deferId) {
        if (prefetchResult instanceof Promise) {
            state = prefetchResult.then((deferredData) => deferredData.data[deferId]);
        }
        else {
            state = prefetchResult.data[deferId];
        }
    }
    else {
        state = prefetchResult;
    }
    const [prefetchState, setPrefetchState] = useState(state);
    const prefetchInstance = MFDataPrefetch.getInstance(mfScope);
    useEffect(() => {
        const useEffectTiming = performance.now();
        logger.info(`3. Start Execute UseEffect: ${options.id} - ${options.functionId || 'default'} - ${useEffectTiming}`);
        return () => {
            prefetchInstance === null || prefetchInstance === void 0 ? void 0 : prefetchInstance.markOutdate(prefetchInfo, true);
        };
    }, []);
    const refreshExecutor = (refetchParams) => {
        const refetchOptions = Object.assign({}, options);
        if (refetchParams) {
            refetchOptions.refetchParams = refetchParams;
        }
        prefetchInstance === null || prefetchInstance === void 0 ? void 0 : prefetchInstance.markOutdate(prefetchInfo, true);
        const newVal = prefetch(refetchOptions);
        let newState;
        if (deferId) {
            if (newVal instanceof Promise) {
                newState = newVal.then((deferredData) => deferredData.data[deferId]);
            }
            else {
                newState = newVal.data[deferId];
            }
        }
        else {
            newState = newVal;
        }
        setPrefetchState(newState);
    };
    return [prefetchState, refreshExecutor];
};
